module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/logo_teams2025.95533d03cd2c18096f458ea5f26b6eaf.svg";